import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-829d0618"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "loading-screen-body" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ClientLogo = _resolveComponent("ClientLogo")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["loading-screen", _ctx.className])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_ClientLogo, { className: "logo" }),
      _hoisted_2
    ])
  ], 2))
}